import { useState, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://vcawzbgksrbkoyughstw.supabase.co";
const SUPABASE_KEY = "sb_publishable_8XHaA2Y2TSmb5Nw62Oy0mA_OrZ_TQ7B";
const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

function Estrelas({ value, onChange }) {
  return (
    <div style={{ display:"flex", gap:6, justifyContent:"center" }}>
      {[1,2,3,4,5].map(n => (
        <button key={n} onClick={()=>onChange(n)} type="button" style={{ background:"none", border:"none", fontSize:32, cursor:"pointer", color: n <= (value||0) ? "#f59e0b" : "#d1d5db", padding:4, lineHeight:1 }}>
          ★
        </button>
      ))}
    </div>
  );
}

function NPS({ value, onChange }) {
  return (
    <div style={{ display:"flex", gap:4, flexWrap:"wrap", justifyContent:"center" }}>
      {[0,1,2,3,4,5,6,7,8,9,10].map(n => {
        const active = n === value;
        const cor = n <= 6 ? "#dc2626" : n <= 8 ? "#f59e0b" : "#16a34a";
        return (
          <button key={n} onClick={()=>onChange(n)} type="button" style={{ width:38, height:38, borderRadius:8, border:`2px solid ${cor}`, background: active?cor:"#fff", color: active?"#fff":cor, fontSize:14, fontWeight:700, cursor:"pointer" }}>{n}</button>
        );
      })}
    </div>
  );
}

export default function FormularioSatisfacaoPublico({ token }) {
  const [form, setForm] = useState(null);
  const [consultor, setConsultor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [r, setR] = useState({
    avaliacao_geral: 0, avaliacao_profissionalismo: 0, avaliacao_comunicacao: 0,
    avaliacao_rapidez: 0, avaliacao_apoio: 0,
    nps_recomendaria: null, recomendaria_amigos: "",
    o_que_correu_bem: "", o_que_pode_melhorar: "",
    testemunho_publico: "", autoriza_testemunho: false,
  });

  useEffect(() => {
    if (!token) return;
    (async () => {
      // Lê através de função no Supabase que só devolve o formulário deste token
      // (a tabela não está aberta ao público)
      const { data: rows } = await supabase.rpc("obter_formulario_satisfacao", { p_token: token });
      const f = Array.isArray(rows) ? rows[0] : null;
      if (!f) { setLoading(false); return; }
      setForm(f);
      if (f.preenchido_em) setSubmitted(true);
      // Só as redes do consultor DESTE formulário (a função exige o token)
      const { data: rr } = await supabase.rpc("redes_consultor_formulario", { p_token: token });
      setConsultor((Array.isArray(rr) ? rr[0] : null) || { nome: f.consultor_nome });
      setLoading(false);
    })();
  }, [token]);

  const submit = async () => {
    if (!r.avaliacao_geral) { alert("Por favor avalie o serviço geral."); return; }
    setSubmitting(true);
    // Grava as respostas e notifica consultor + líder numa só função no Supabase
    // (só aceita uma resposta por token)
    const { error } = await supabase.rpc("responder_formulario_satisfacao", { p_token: token, p: r });
    setSubmitting(false);
    if (error) { alert("Não foi possível enviar a resposta. Por favor tente novamente."); return; }
    setSubmitted(true);
  };

  const setField = (k, v) => setR(p => ({ ...p, [k]: v }));

  if (loading) return <div style={{ padding:40, textAlign:"center", fontFamily:"Arial,sans-serif" }}>A carregar...</div>;
  if (!form) return <div style={{ padding:40, textAlign:"center", fontFamily:"Arial,sans-serif", color:"#dc2626" }}>Link inválido ou expirado.</div>;
  if (submitted) {
    const redes = consultor ? [
      { id:"google", l:"⭐ Google Reviews", url: consultor.link_google_reviews },
      { id:"facebook", l:"👍 Facebook", url: consultor.link_facebook },
      { id:"instagram", l:"📸 Instagram", url: consultor.link_instagram },
      { id:"linkedin", l:"💼 LinkedIn", url: consultor.link_linkedin },
      { id:"idealista", l:"🏠 Idealista", url: consultor.link_idealista },
      { id:"tiktok", l:"🎵 TikTok", url: consultor.link_tiktok },
    ].filter(x => x.url) : [];
    return (
      <div style={{ minHeight:"100vh", background:"linear-gradient(135deg,#f0fdf4 0%,#ecfdf5 100%)", padding:"40px 20px", fontFamily:"'Helvetica Neue',Arial,sans-serif" }}>
        <div style={{ maxWidth:520, margin:"auto", background:"#fff", borderRadius:18, padding:30, boxShadow:"0 8px 30px rgba(0,0,0,0.08)", textAlign:"center" }}>
          <div style={{ fontSize:50, marginBottom:14 }}>🎉</div>
          <h1 style={{ fontFamily:"Georgia,serif", fontSize:24, color:"#16a34a", margin:"0 0 10px 0" }}>Obrigado!</h1>
          <p style={{ color:"#374151", fontSize:14, marginBottom:20 }}>A sua avaliação foi registada. Significa muito para nós!</p>
          {redes.length > 0 && (
            <div style={{ background:"#f8f7f4", borderRadius:12, padding:16, marginTop:20 }}>
              <div style={{ fontWeight:700, fontSize:13, marginBottom:10 }}>💡 Pode também avaliar {consultor?.nome||"o consultor"} nas redes sociais:</div>
              <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                {redes.map(r => (
                  <a key={r.id} href={r.url} target="_blank" rel="noreferrer" style={{ background:"#fff", border:"1.5px solid #ece9e3", borderRadius:8, padding:"10px 14px", textDecoration:"none", color:"#1a1a2e", fontWeight:600, fontSize:13, transition:"transform 0.1s" }}>
                    {r.l} →
                  </a>
                ))}
              </div>
            </div>
          )}
          <div style={{ marginTop:30, fontSize:11, color:"#9ca3af" }}>Equipa Sónia Cunha · RE/MAX White</div>
        </div>
      </div>
    );
  }

  const consNome = consultor?.nome || form.consultor_nome || "o seu consultor";
  const primeiroNome = consNome.split(" ")[0];

  return (
    <div style={{ minHeight:"100vh", background:"#f8f7f4", padding:"30px 16px", fontFamily:"'Helvetica Neue',Arial,sans-serif" }}>
      <div style={{ maxWidth:600, margin:"auto", background:"#fff", borderRadius:18, padding:"28px 24px", boxShadow:"0 8px 30px rgba(0,0,0,0.06)" }}>
        <div style={{ textAlign:"center", marginBottom:24 }}>
          <div style={{ fontSize:11, color:"#c8102e", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.08em" }}>Equipa Sónia Cunha · RE/MAX White</div>
          <h1 style={{ fontFamily:"Georgia,serif", fontSize:24, color:"#1a1a2e", margin:"6px 0 10px 0" }}>⭐ Avaliação do Serviço</h1>
          {form.referencia && <div style={{ fontSize:11, color:"#9ca3af", marginTop:-6, marginBottom:8 }}>Ref. {form.referencia}</div>}
          <p style={{ color:"#6b7280", fontSize:13, margin:0 }}>Olá! Obrigado por confiar em <strong>{consNome}</strong>. A sua opinião é muito importante (2 minutos).</p>
        </div>

        {[
          { k:"avaliacao_geral", l:"1. Avaliação geral" },
          { k:"avaliacao_profissionalismo", l:`2. Profissionalismo do(a) ${primeiroNome}` },
          { k:"avaliacao_comunicacao", l:"3. Comunicação ao longo do processo" },
          { k:"avaliacao_rapidez", l:"4. Rapidez do processo" },
          { k:"avaliacao_apoio", l:"5. Apoio fora do habitual" },
        ].map(q => (
          <div key={q.k} style={{ marginBottom:18, padding:"14px 16px", background:"#f8f7f4", borderRadius:12 }}>
            <div style={{ fontSize:13, fontWeight:600, marginBottom:8, color:"#1a1a2e" }}>{q.l}</div>
            <Estrelas value={r[q.k]} onChange={v => setField(q.k, v)} />
          </div>
        ))}

        <div style={{ marginBottom:18, padding:"14px 16px", background:"#f8f7f4", borderRadius:12 }}>
          <div style={{ fontSize:13, fontWeight:600, marginBottom:8 }}>6. Numa escala 0-10, qual a probabilidade de nos recomendar a um amigo?</div>
          <NPS value={r.nps_recomendaria} onChange={v => setField("nps_recomendaria", v)} />
        </div>

        <div style={{ marginBottom:18, padding:"14px 16px", background:"#f8f7f4", borderRadius:12 }}>
          <div style={{ fontSize:13, fontWeight:600, marginBottom:8 }}>7. Recomendaria o(a) {consNome} a um amigo?</div>
          <div style={{ display:"flex", gap:8 }}>
            {[{v:"sim",l:"Sim"},{v:"nao",l:"Não"},{v:"talvez",l:"Talvez"}].map(o => (
              <button key={o.v} type="button" onClick={()=>setField("recomendaria_amigos",o.v)} style={{ flex:1, padding:"10px", borderRadius:8, border:"1.5px solid", borderColor: r.recomendaria_amigos===o.v?"#16a34a":"#ece9e3", background: r.recomendaria_amigos===o.v?"#16a34a":"#fff", color: r.recomendaria_amigos===o.v?"#fff":"#374151", fontSize:13, fontWeight:600, cursor:"pointer" }}>{o.l}</button>
            ))}
          </div>
        </div>

        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:12, fontWeight:600, color:"#6b7280", display:"block", marginBottom:5 }}>8. O que correu bem?</label>
          <textarea value={r.o_que_correu_bem} onChange={e=>setField("o_que_correu_bem",e.target.value)} rows={2} style={{ width:"100%", padding:"10px 12px", border:"1.5px solid #ece9e3", borderRadius:10, fontSize:13, fontFamily:"inherit", boxSizing:"border-box", resize:"vertical" }} />
        </div>

        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:12, fontWeight:600, color:"#6b7280", display:"block", marginBottom:5 }}>9. O que pode melhorar?</label>
          <textarea value={r.o_que_pode_melhorar} onChange={e=>setField("o_que_pode_melhorar",e.target.value)} rows={2} style={{ width:"100%", padding:"10px 12px", border:"1.5px solid #ece9e3", borderRadius:10, fontSize:13, fontFamily:"inherit", boxSizing:"border-box", resize:"vertical" }} />
        </div>

        <div style={{ marginBottom:14, padding:"14px 16px", background:"#fffbeb", borderRadius:12, border:"1.5px solid #fde68a" }}>
          <label style={{ fontSize:13, fontWeight:600, color:"#92400e", display:"block", marginBottom:6 }}>10. Quer deixar um testemunho público?</label>
          <textarea value={r.testemunho_publico} onChange={e=>setField("testemunho_publico",e.target.value)} rows={3} placeholder="Pode escrever algumas linhas..." style={{ width:"100%", padding:"10px 12px", border:"1.5px solid #fde68a", borderRadius:10, fontSize:13, fontFamily:"inherit", boxSizing:"border-box", resize:"vertical", background:"#fff" }} />
          <label style={{ display:"flex", alignItems:"center", gap:8, marginTop:8, fontSize:12, color:"#374151", cursor:"pointer" }}>
            <input type="checkbox" checked={r.autoriza_testemunho} onChange={e=>setField("autoriza_testemunho",e.target.checked)} />
            <span>Autorizo a Equipa Sónia Cunha a usar este testemunho</span>
          </label>
          {(consultor?.link_google_reviews || consultor?.link_facebook || consultor?.link_instagram || consultor?.link_linkedin || consultor?.link_idealista || consultor?.link_tiktok) && (
            <div style={{ marginTop:10, paddingTop:10, borderTop:"1px dashed #fde68a" }}>
              <div style={{ fontSize:11, color:"#92400e", marginBottom:6 }}>💡 Pode também publicar a sua avaliação nas redes do(a) {primeiroNome}:</div>
              <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
                {consultor.link_google_reviews && <a href={consultor.link_google_reviews} target="_blank" rel="noreferrer" style={{ background:"#fff", border:"1px solid #fde68a", borderRadius:6, padding:"4px 10px", textDecoration:"none", color:"#92400e", fontSize:11, fontWeight:600 }}>⭐ Google</a>}
                {consultor.link_facebook && <a href={consultor.link_facebook} target="_blank" rel="noreferrer" style={{ background:"#fff", border:"1px solid #fde68a", borderRadius:6, padding:"4px 10px", textDecoration:"none", color:"#92400e", fontSize:11, fontWeight:600 }}>👍 Facebook</a>}
                {consultor.link_instagram && <a href={consultor.link_instagram} target="_blank" rel="noreferrer" style={{ background:"#fff", border:"1px solid #fde68a", borderRadius:6, padding:"4px 10px", textDecoration:"none", color:"#92400e", fontSize:11, fontWeight:600 }}>📸 Instagram</a>}
                {consultor.link_linkedin && <a href={consultor.link_linkedin} target="_blank" rel="noreferrer" style={{ background:"#fff", border:"1px solid #fde68a", borderRadius:6, padding:"4px 10px", textDecoration:"none", color:"#92400e", fontSize:11, fontWeight:600 }}>💼 LinkedIn</a>}
                {consultor.link_idealista && <a href={consultor.link_idealista} target="_blank" rel="noreferrer" style={{ background:"#fff", border:"1px solid #fde68a", borderRadius:6, padding:"4px 10px", textDecoration:"none", color:"#92400e", fontSize:11, fontWeight:600 }}>🏠 Idealista</a>}
                {consultor.link_tiktok && <a href={consultor.link_tiktok} target="_blank" rel="noreferrer" style={{ background:"#fff", border:"1px solid #fde68a", borderRadius:6, padding:"4px 10px", textDecoration:"none", color:"#92400e", fontSize:11, fontWeight:600 }}>🎵 TikTok</a>}
              </div>
            </div>
          )}
        </div>

        <button onClick={submit} disabled={submitting} style={{ width:"100%", background:"#c8102e", color:"#fff", border:"none", borderRadius:12, padding:"14px", fontSize:15, fontWeight:700, cursor:"pointer", marginTop:8, opacity:submitting?0.7:1 }}>
          {submitting ? "A enviar..." : "Submeter Avaliação"}
        </button>

        <div style={{ marginTop:16, fontSize:11, color:"#9ca3af", textAlign:"center" }}>
          Os seus dados são tratados confidencialmente. Equipa Sónia Cunha · RE/MAX White.
        </div>
      </div>
    </div>
  );
}
